module.exports = __webpack_public_path__ + "img/guam.2066c9b.webp";